(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fb-cart-checkout-confidence"] && !Shopify.designMode) return;
  try {
    class FbCartCheckoutConfidence extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.offerElement = this.querySelector('[data-fb-cart-offer]');
      this.renderOffer();
    }

    fillTemplate(template, values) {
      return Object.keys(values).reduce((copy, key) => copy.replaceAll(`[${key}]`, values[key]), template || '');
    }

    formatMoney(cents) {
      const currency = this.dataset.currency || 'GBP';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(cents) / 100);
    }

    renderOffer() {
      const state = {
        brand: this.dataset.offerBrand,
        quantity: Number(this.dataset.offerQuantity || 0),
        percentage: Number(this.dataset.offerPercentage || 0),
        needed: Number(this.dataset.offerNeeded || 0),
        code: this.dataset.offerCode,
        appliedTitle: this.dataset.offerAppliedTitle,
        collection: this.dataset.offerCollection,
        offerUrl: this.dataset.offerUrl,
        cartAddUrl: this.dataset.cartAddUrl,
        cartUrl: this.dataset.cartUrl,
        discountUrl: this.dataset.discountUrl,
        product: {
          variantId: this.dataset.productVariantId,
          url: this.dataset.productUrl,
          title: this.dataset.productTitle,
          price: this.dataset.productPrice,
          image: this.dataset.productImage,
        },
      };
      if (!state.brand || !state.collection) return;

      const { brand, quantity, percentage, needed, code, appliedTitle, offerUrl, product } = state;
      const heading = this.querySelector('[data-fb-cart-offer-heading]');
      const message = this.querySelector('[data-fb-cart-offer-message]');
      const productLink = this.querySelector('[data-fb-cart-product-link]');
      const productImage = this.querySelector('[data-fb-cart-product-image]');
      const productTitle = this.querySelector('[data-fb-cart-product-title]');
      const productPrice = this.querySelector('[data-fb-cart-product-price]');
      const action = this.querySelector('[data-fb-cart-offer-action]');
      const fallback = this.querySelector('[data-fb-cart-offer-fallback]');
      const twoTier = this.querySelector('[data-fb-cart-tier="2"]');
      const threeTier = this.querySelector('[data-fb-cart-tier="3"]');
      const hasProduct = Boolean(product.variantId);

      heading.textContent = `${brand} ${heading.textContent}`;
      twoTier.classList.toggle('is-active', quantity < 2);
      twoTier.classList.toggle('is-complete', quantity >= 2);
      threeTier.classList.toggle('is-active', quantity >= 2 && quantity < 3);
      threeTier.classList.toggle('is-complete', quantity >= 3);

      if (appliedTitle) {
        message.textContent = this.fillTemplate(this.dataset.offerApplied, { title: appliedTitle });
      } else if (needed > 0) {
        const template = quantity === 1 ? this.dataset.offerOne : this.dataset.offerTwo;
        message.textContent = this.fillTemplate(template, { brand, percentage });
      } else {
        message.textContent = this.fillTemplate(this.dataset.offerReady, { brand, percentage });
      }

      productLink.hidden = !hasProduct || Boolean(appliedTitle) || !needed;
      action.hidden = Boolean(appliedTitle) || (needed > 0 && !hasProduct);
      fallback.hidden = hasProduct || Boolean(appliedTitle) || !needed;
      fallback.href = offerUrl;
      fallback.textContent = this.fillTemplate(this.dataset.offerFallback, { brand });

      if (hasProduct && !appliedTitle && needed) {
        productLink.href = product.url;
        productImage.src = product.image;
        productImage.alt = product.title;
        productTitle.textContent = product.title;
        productPrice.textContent = this.formatMoney(product.price);
        action.textContent = needed > 0
          ? this.fillTemplate(action.dataset.addLabel || '', { percentage })
          : this.fillTemplate(action.dataset.applyLabel || '', { percentage });
        action.dataset.variantId = product.variantId;
        action.dataset.discountCode = code;
        action.dataset.shouldAdd = needed > 0 ? 'true' : 'false';
        action.onclick = () => this.applyOffer(action);
      } else if (!appliedTitle && !needed) {
        action.textContent = this.fillTemplate(action.dataset.applyLabel || '', { percentage });
        action.dataset.variantId = '';
        action.dataset.discountCode = code;
        action.dataset.shouldAdd = 'false';
        action.onclick = () => this.applyOffer(action);
      }

      this.offerElement.hidden = false;
    }

    async applyOffer(action) {
      if (action.dataset.busy === 'true') return;
      action.dataset.busy = 'true';
      action.disabled = true;
      const errorMessage = this.querySelector('[data-fb-cart-offer-error]');
      errorMessage.hidden = true;

      try {
        if (action.dataset.shouldAdd === 'true' && action.dataset.variantId) {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: action.dataset.variantId, quantity: 1 }] }),
          });
          if (!response.ok) throw new Error('Unable to add the recommended product');
        }
        window.location.assign(`${this.dataset.discountUrl}${encodeURIComponent(action.dataset.discountCode)}?redirect=${encodeURIComponent(this.dataset.cartUrl)}`);
      } catch (error) {
        action.disabled = false;
        action.dataset.busy = 'false';
        errorMessage.textContent = errorMessage.dataset.message;
        errorMessage.hidden = false;
      }
    }
  }

  if (!customElements.get('fb-cart-checkout-confidence')) {
    customElements.define('fb-cart-checkout-confidence', FbCartCheckoutConfidence);
  }
  } catch(e) { console.error(e); }
})();

})();
